module.exports = __webpack_public_path__ + "img/1.39e8b545.png";